import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { refreshCachedDevice } from '@/api/devices';
import { PostDeactivateWaveHeightAlertPayload, PostDeactivateWaveHeightAlertResponse } from '@/api/waveHeight/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';

export const postDeactivateWaveHeightAlert = (
    payload: PostDeactivateWaveHeightAlertPayload
): Promise<PostDeactivateWaveHeightAlertResponse> => {
    return axios.post('/device/deactivate-waveheightalert', payload);
};

type UsePostDeactivateWaveHeightAlertOptions = {
    config?: MutationConfig<typeof postDeactivateWaveHeightAlert>;
    data?: PostDeactivateWaveHeightAlertPayload;
};

export const usePostDeactivateWaveHeightAlert = ({ config }: UsePostDeactivateWaveHeightAlertOptions = {}) => {
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postDeactivateWaveHeightAlert,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Wave height alert deactivated', {
                spotterId: variables.spotterId,
            });
        },
    });
};
